module.exports = __webpack_public_path__ + "static/media/6@3x.ca9f94ec.png";